<div *ngIf="active" class="pane h-100 w-100" [id]="tabId" attr.data-uit="page-tab-{{ tabId }}">
    <ng-content></ng-content>
    <ng-container *ngIf="template" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{ data: dataContext }"> </ng-container>
</div>
